import { SimpleTruncatedTooltipText } from '@elliemae/ds-truncated-tooltip-text';
import React from 'react';
import { LEFT_NAVIGATION_DATA_TESTID } from '../../constants/index.js';
import { ItemRenderer } from '../../exported-related/index.js';
import type { DSLeftNavigationT } from '../../react-desc-prop-types.js';
import { StyledLabel } from '../styled.js';

export const ItemTextLabel = (props: DSLeftNavigationT.ComponentProps): JSX.Element => {
  const {
    item,
    item: {
      itemOpts: { label, labelOverflow: itemLabelOverflow, labelBold, labelColor, labelDataTestId },
    },
    ctx: {
      leftNavProps,
      leftNavProps: { labelOverflow: leftNavLabelOverflow },
    },
  } = props;
  const getOwnerProps = React.useCallback(() => leftNavProps, [leftNavProps]);
  const getOwnerPropsArguments = React.useCallback(() => ({}), []);

  const labelOverflow = itemLabelOverflow || leftNavLabelOverflow;
  return (
    <ItemRenderer
      item={{
        ...item,
        CollapsedComponent: null,
      }}
      minHeight="32px"
      paddingTop="8px"
    >
      {/* Empty LeftComponent */} <div />
      <StyledLabel
        pl="24px"
        labelOverflow={labelOverflow}
        labelBold={labelBold}
        labelColor={labelColor}
        mr="xxs2"
        pb="xxxs"
        data-testid={labelDataTestId || LEFT_NAVIGATION_DATA_TESTID.LIST_ITEM_LABEL_ID_EXCEPTION}
        getOwnerProps={getOwnerProps}
        getOwnerPropsArguments={getOwnerPropsArguments}
      >
        {labelOverflow === 'truncate' ? <SimpleTruncatedTooltipText value={label} placement="bottom-start" /> : label}
      </StyledLabel>
    </ItemRenderer>
  );
};
